import { useClientCategories } from "api/Client/category";
import { useClientProducts } from "api/Client/product";
import { image_host } from "config/api_host";
import { motion } from "framer-motion";
import { useState } from "react";
import { FaInfoCircle, FaSearch } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";

import SpotlightCard from "components/home/SpotlightCard";

import laplap from "assets/laplap.png";
import LogoSpinner from "components/Spinner/LogoSpinner";

function Laptops() {
  const { type } = useParams();
  const { prand } = useParams();

  const {
    data: categories,
    isLoading: categoriesIsLoading,
    isSuccess: categoriesIsSuccess,
    isError: categoriesIsError,
  } = useClientCategories(type);

  const {
    data: product,
    isLoading: productIsLoading,
    isSuccess: productIsSuccess,
  } = useClientProducts(prand);

  if (!type && !prand) {
    // الحالة الأولى: لا يوجد أي منهما
    return (
      <section className="py-24_ px-4 mt-8">
        <div className="container mx-auto text-center max-w-6xl">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-6 max-w-4xl mx-auto mb-12">
            <h2 className="text-3xl font-bold text-mainLight">
              اللابتوبات
            </h2>
            <Link
              to="search"
              className="group flex items-center gap-3 px-6 py-4 rounded-2xl border-2 border-mainLight/20 hover:border-mainLight/50 bg-gradient-to-br from-white/10 to-transparent hover:from-mainLight/10 hover:to-mainLight/5 transition-all duration-300 shadow-lg hover:shadow-mainLight/20 hover:-translate-y-0.5 active:scale-[0.98]"
            >
              <span className="p-2 rounded-xl bg-mainLight/10 group-hover:bg-mainLight/20 transition-colors">
                <FaSearch className="text-mainLight text-xl" />
              </span>
              <span className="text-xl font-bold text-mainLight group-hover:text-mainLight">
                البحث
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 mb-8 max-w-4xl mx-auto">
            <Link to={"/laptops/offers"} className="group">
              <SpotlightCard className="relative p-10 overflow-hidden border-2 border-red-500/20 hover:border-red-500/50 transition-all duration-500 bg-gradient-to-br from-white/10 to-transparent">
                <div className="absolute -right-1 -top-10 text-red-500/5 text-9xl font-bold italic select-none">
                  OFFERS
                </div>

                <img
                  src={laplap}
                  alt="عروض"
                  className="mx-auto mb-6 w-48 drop-shadow-2xl group-hover:-rotate-3 transition-transform duration-500"
                />
                <h3 className="text-3xl font-bold mb-3 text-red-400">العروض</h3>
                <p className="text-gray-400 text-lg leading-relaxed">
                  عروض حصرية على أفضل الأجهزة الجديدة والأوروبية، جودة عالية
                  وأسعار مدروسة مع ضماننا الخاص لراحة بالك.
                </p>
              </SpotlightCard>
            </Link>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Link to={"/laptops/new"} className="group">
              <SpotlightCard className="relative p-10 overflow-hidden border-2 border-mainLight/20 hover:border-mainLight/50 transition-all duration-500 bg-gradient-to-br from-white/10 to-transparent">
                {/* خلفية جمالية */}
                <div className="absolute -right-1 -top-10 text-mainLight/5 text-9xl font-bold italic select-none">
                  NEW
                </div>

                <img
                  src={laplap}
                  alt="جديد"
                  className="mx-auto mb-6 w-48 drop-shadow-2xl group-hover:rotate-3 transition-transform duration-500"
                />
                <h3 className="text-3xl font-bold mb-3 text-mainLight">
                  لابتوبات جديدة
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed">
                  تكنولوجيا الغد بين يديك اليوم. أجهزة جديدة تماماً بضمان
                  الوكيل.
                </p>
              </SpotlightCard>
            </Link>

            <Link to={"/laptops/europ"} className="group">
              <SpotlightCard className="relative p-10 overflow-hidden border-2 border-blue-500/20 hover:border-blue-500/50 transition-all duration-500 bg-gradient-to-br from-white/10 to-transparent">
                <div className="absolute -right-1 -top-10 text-blue-500/5 text-9xl font-bold italic select-none">
                  EURO
                </div>

                <img
                  src={laplap}
                  alt="بالة"
                  className="mx-auto mb-6 w-48 drop-shadow-2xl group-hover:-rotate-3 transition-transform duration-500"
                />
                <h3 className="text-3xl font-bold mb-3 text-blue-400">
                  بالة أوربية
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed">
                  القوة الأوربية بأسعار منافسة. أجهزة مختارة بعناية فائقة
                  وضماننا الخاص.
                </p>
              </SpotlightCard>
            </Link>
          </div>
        </div>
      </section>
    );
  }

  if (type && !prand) {
    // الحالة الثانية: يوجد type فقط
    return (
      <>
        {categoriesIsLoading && <LogoSpinner />}
        {categoriesIsSuccess && (
          <section className="p-4 py-6 font-[Tajawal] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 max-w-6xl mx-auto w-full h-fit">
            {categories.data.categories.map((prand) => (
              <LaptopPrand key={prand.id} prand={prand} />
            ))}
          </section>
        )}
      </>
    );
  }

  if (type && prand) {
    // الحالة الثالثة: يوجد الاثنان معًا
    return (
      <>
        {productIsLoading && <LogoSpinner />}
        {productIsSuccess && product.data.products.length == 0 && (
          <>
            {/* Header */}

            <div className="py-24 m-6 text-center max-w-6xl h-fit mx-auto w-full bg-gray-100 dark:bg-white/5 rounded-[3rem] border-2 border-dashed border-gray-200 dark:border-white/10">
              <div className="text-6xl mb-6 grayscale opacity-50">💻</div>
              <h3 className="text-xl font-bold text-gray-500 dark:text-gray-300">
                هذا القسم فارغ حالياً{" "}
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 leading-relaxed">
                <br />
                ترقّب جديدنا قريباً ✨
              </p>
            </div>
          </>
        )}
        {productIsSuccess && (
          <section className="p-4 py-6 font-[Tajawal] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto w-full">
            {product.data.products.map((lap) => (
              <LaptopCard key={lap.id} laptop={lap} />
            ))}
          </section>
        )}
      </>
    );
  }
}

function LaptopCard({ laptop }) {
  const [flipped, setFlipped] = useState(false);

  const technicalFields = laptop.fields ? laptop.fields : [];
  const isAvailable = laptop.quantity > 0 || laptop.isAvailable === 1;
  const hasDiscount =
    Number(laptop.discountPriceDollar) > 0 &&
    Number(laptop.discountPriceDollar) < Number(laptop.salesPriceDollar);

  return (
    <div
      className="relative w-full h-[450px] [perspective:1500px] group cursor-pointer"
      onClick={() => setFlipped(!flipped)}
    >
      <motion.div
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.7, type: "spring", stiffness: 100 }}
        className="relative w-full h-full [transform-style:preserve-3d]"
      >
        {/* --- الوجه الأمامي: العرض التسويقي --- */}
        <div className="absolute inset-0 rounded-[2rem] border border-gray-200 dark:border-white/10 p-4 bg-gray-100 dark:bg-white/5 backdrop-blur-md [backface-visibility:hidden] flex flex-col items-center shadow-xl dark:shadow-2xl transition-colors duration-300">
          {/* شارة التوفر */}
          <div
            className={`absolute top-4 right-4 px-3 py-1 rounded-full text-[10px] font-bold z-10 ${
              isAvailable
                ? "bg-green-100 dark:bg-green-500/20 text-green-600 dark:text-green-400"
                : "bg-red-100 dark:bg-red-500/20 text-red-600 dark:text-red-400"
            }`}
          >
            {isAvailable ? "متوفر في المخزن" : "نفدت الكمية"}
          </div>

          {/* شارة الخصم */}
          {hasDiscount && (
            <div className="absolute top-4 left-4 bg-red-500 text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-lg z-20 animate-bounce">
              خصم{" "}
              {Math.round(
                ((laptop.salesPriceDollar - laptop.discountPriceDollar) /
                  laptop.salesPriceDollar) *
                  100
              )}
              %
            </div>
          )}

          {/* صورة المنتج */}
          <div className="mt-8 relative h-36 flex items-center">
            <div className="absolute inset-0 bg-mainLight/20 dark:bg-mainLight/10 blur-3xl rounded-full opacity-50 dark:opacity-100"></div>
            <img
              src={image_host + laptop.image}
              alt={laptop.name}
              className="relative z-10 w-48 h-full object-contain drop-shadow-xl dark:drop-shadow-[0_15px_30px_rgba(0,0,0,0.4)]"
            />
          </div>

          {/* النصوص */}
          <div className="text-center mt-4 w-full px-2">
            <span className="text-mainLight text-xs font-bold tracking-widest uppercase opacity-80">
              {laptop.companyName}
            </span>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white mt-1 truncate">
              {laptop.name}
            </h3>
            {laptop.desc && (
              <p className="text-gray-500 dark:text-gray-400 text-xs mt-2 line-clamp-3 leading-relaxed">
                {laptop.desc}
              </p>
            )}
          </div>

          {/* السعر */}
          <div className="mt-auto w-full flex justify-center items-center gap-3 bg-gray-50 dark:bg-white/5 py-3 rounded-2xl border border-gray-100 dark:border-white/5 transition-colors">
            {hasDiscount ? (
              <>
                <s className="text-gray-400 dark:text-gray-500 font-bold text-sm">
                  ${Number(laptop.salesPriceDollar).toLocaleString()}
                </s>
                <span className="text-mainLight font-bold text-xl">
                  ${Number(laptop.discountPriceDollar).toLocaleString()}
                </span>
              </>
            ) : (
              <span className="text-mainLight font-bold text-xl">
                ${Number(laptop.salesPriceDollar).toLocaleString()}
              </span>
            )}
          </div>
        </div>

        {/* --- الوجه الخلفي: المعلومات الكاملة --- */}
        <div className="absolute inset-0 rounded-[2rem] border border-mainLight/30 p-4 bg-gray-200 dark:bg-mainDark/95 backdrop-blur-2xl [transform:rotateY(180deg)] [backface-visibility:hidden] flex flex-col shadow-2xl transition-colors duration-300">
          <div className="flex justify-between items-start mb-4">
            <div className="text-right">
              <h4 className="text-gray-800 dark:text-white font-bold text-lg">
                {laptop.name}
              </h4>
              <p className="text-mainLight text-xs font-bold uppercase">
                Technical Specs
              </p>
            </div>
            <div className="bg-mainLight/10 dark:bg-mainLight/20 p-2 rounded-lg">
              <FaInfoCircle className="text-mainLight" />
            </div>
          </div>

          {/* المواصفات */}
          <div className="grid grid-cols-2 gap-3 flex-1 overflow-y-auto pt-1 pb-2 custom-scrollbar">
            {technicalFields.map((field, idx) => (
              <div
                key={idx}
                className="bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/10 p-1.5 h-12 rounded-xl flex flex-col items-center justify-center text-center transition-colors"
              >
                <span className="text-[9px] text-gray-400 dark:text-gray-500 font-bold uppercase">
                  {field.name}
                </span>
                <span className="text-gray-700 dark:text-white text-xs font-bold truncate w-full px-1">
                  {field.value}
                </span>
              </div>
            ))}
          </div>

          {/* الكمية */}
          <div className="bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/10 p-2 rounded-xl h-12 flex flex-col items-center justify-center text-center mb-4 transition-colors">
            <span className="text-[9px] text-gray-400 dark:text-gray-500 font-bold uppercase">
              الكمية المتاحة
            </span>
            <span
              className={`text-xs font-bold ${
                laptop.quantity < 5
                  ? "text-orange-500"
                  : "text-gray-700 dark:text-white"
              }`}
            >
              {laptop.quantity} قطعة
            </span>
          </div>

          {/* زر الشراء */}
          <div className="mt-auto">
            <Link
              to={`/product/${laptop.id}`}
              onClick={(e) => e.stopPropagation()}
              className="block w-full py-3 rounded-xl bg-mainLight text-mainDark font-bold text-center text-sm shadow-lg hover:scale-[1.02] active:scale-95 transition-all"
            >
              المزيد من التفاصيل
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

function Tags({ data }) {
  return (
    <div className="grid grid-cols-2 gap-2 text-sm">
      {data.map((t) => (
        <Tag label={t.name} value={t.value || " - - "} />
      ))}
    </div>
  );
}

function Tag({ label, value }) {
  return (
    <div className="flex flex-col border border-gray-300/30 dark:border-gray-600 rounded-lg p-2 text-center">
      <span className="text-[11px] uppercase text-gray-400">{label}</span>
      <span className="font-medium text-sm truncate">{value}</span>
    </div>
  );
}

function LaptopPrand({ prand }) {
  return (
    <motion.div whileHover={{ y: -10 }} className="relative group h-fit">
      <Link to={`${prand.id}`} className="flex flex-col items-center gap-4">
        <div className="relative w-full aspect-square flex items-center justify-center p-8 rounded-[2.5rem] bg-white/5 border border-white/10 backdrop-blur-xl shadow-2xl_ group-hover:border-mainLight/40 group-hover:shadow-mainLight/10 transition-all duration-500">
          {/* تأثير الضوء خلف الشعار */}
          <div className="absolute inset-0 bg-mainLight/5 opacity-0 group-hover:opacity-100 rounded-[2.5rem] blur-2xl transition-opacity"></div>

          <img
            src={image_host + prand.image}
            alt={prand.name}
            className="w-full h-full object-contain filter   transition-all duration-500 drop-shadow-lg"
          />
        </div>
        <h3 className="text-xl font-bold text-gray-300 group-hover:text-mainLight transition-colors">
          {prand.name}
        </h3>
      </Link>
    </motion.div>
  );
}

export default Laptops;
